import Config from 'config';
import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';
import fieldsStore from '../../components/apia/execution/fieldsStore/fieldsStore';
import { ApiaUtil } from '@apia/components';

export interface IInputField extends IApiaField {
  getObjectValue(): number | string | boolean | null;
  setValue(value: string): IInputField;
}

export default class InputField extends ApiaField implements IInputField {
  constructor(field: HTMLInputElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_INPUT_AS_TEXT,
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_MODAL_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_VISIBILITY_HIDDEN,
      Field.PROPERTY_STORE_MODAL_QUERY_RESULT,
      Field.PROPERTY_TRANSLATION_REQUIRED,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
  }

  getObjectValue(): number | string | boolean | null {
    if (this.checkFieldExistsInDocument(this.fldId) && this.fldId !== null) {
      if (this.valueType === 'N') {
        return ApiaUtil.instance.parsers.jsNumber(this.getValue() as string);
      }
      return this.getValue() as string;
    }
    return null;
  }

  setValue(value: string | number, isAjax?: boolean): IInputField {
    let val = value;
    if (this.props.field?.qryId) {
      if (this.fldId) {
        const field = fieldsStore.getById(this.fldId);
        field.setValue(val);
        field.fireEvent('JSApiaUpdate');
      }
    } else {
      if (this.valueType === 'N') {
        if (typeof value === 'number') {
          val = ApiaUtil.instance.parsers.apiaNumber(value);
        } else if (typeof value === 'string') {
          const objNumRegExp = Config.OBJ_NUM_REGEXP;
          if (value === '') {
            val = '';
          } else if (objNumRegExp.test(value)) {
            val = value;
          }
        }
      } else if (this.valueType === 'S') {
        val = value?.toString() ?? '';
      } else {
        val = value;
      }

      super.setValue(val, isAjax);
    }
    return this;
  }
}
